export default __webpack_public_path__ + "static/CL-2-73435e6db78fd0b8095e5b4e741a9f1f.png";